// Module
var code = "<div class=\"grid grid-cols-4 absolute left-0 w-full\"> <div id=\"sideNav\"></div> <div id=\"tabContentContainer\" class=\"col-span-3 w-full min-w-0 max-w-none px-4 sm:px-6 lg:px-8\"></div> </div> ";
// Exports
export default code;